
const PictViewClass = require('pict-view');

class LIMSSampleRecordCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.ActiveSampleLogs = [];
		/** @type {Record<string, any>} */
		this.extendedSchema = null;

		this.AppData.SampleDetails = { };

		this.cloneFrom = null;

		this.manifest = require('./defaultSampleCreateManifest.json');
	}

	async onInitializeAsync(fCallback)
	{
		return super.onInitializeAsync(fCallback);
	}

	async onNavigate(pResetState = true, GUIDSample)
	{
		if (pResetState)
		{
			delete this.AppData.SampleSequence;
			delete this.AppData.LoggedBy;
			delete this.cloneFrom;
			await this.clearSample(false);
		}
		if (GUIDSample)
		{
			this.cloneFrom = GUIDSample;
		}
		await new Promise((resolve) => this.renderAsync((pError) =>
		{
			if (pError)
			{
				this.log.error(`Error rendering Sample view: ${pError.message || pError}`, { stack: pError.stack });
			}
			else
			{
				this.log.info('Sample view rendered');
			}
			resolve();
		}));
	}

	async onBeforeRenderAsync(fCallback, pRenderable)
	{
		const session = await this.pict.providers.SessionProvider.getSession();
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Sample', 'Create', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-SampleCreate'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-SampleCreate'].options.DefaultDestinationAddress = '#LIMSSampleRecordCreate-Container';
			this.pict.views['PictSectionForm-SampleCreate'].rebuildCustomTemplate();
			this.initialized = true;
		}
		if (this.cloneFrom && this.manifest?.Descriptors)
		{
			const clonedFromSample = await this.pict.providers.SampleProvider.getSampleByGUID(this.cloneFrom);
			if (clonedFromSample)
			{
				this.AppData.SampleDetails = { CreatingIDUser: this.AppData.SampleDetails.CreatingIDUser };
				const findPathValue = (tokens, parent = { SampleDetails: clonedFromSample }) =>
				{
					const val = parent?.[tokens[0]];
					return !val ? null : tokens.length == 1 ? val : findPathValue(tokens.slice(1), val);
				};
				const applyPathValue = (tokens, value, parent = this.AppData) =>
				{
					if (tokens.length > 1)
					{
						parent[tokens[0]] = parent[tokens[0]] || {};
						applyPathValue(tokens.slice(1), value, parent[tokens[0]]);
					}
					else if (tokens.length == 1)
					{
						parent[tokens[0]] = value;
					}
				};
				// @ts-ignore
				for (const d of Object.keys(this.manifest.Descriptors))
				{
					const path = this.manifest.Descriptors[d]?.DataAddress || d;
					const val = findPathValue(path.split('.'));
					if (val)
					{
						applyPathValue(path.split('.'), val);
					}
				}
			}
		}
		return super.onBeforeRenderAsync(() =>
		{
			this.pict.views['PictSectionForm-SampleCreate'].rebuildCustomTemplate();
			this.pict.providers.FormInitialBundle.gatherInitialBundle(this.manifest, (pError) =>
			{
				if (pError && this.pict.providers.FormInitialBundle.hasProjectDatasetStep(this.manifest.InitialBundle))
				{
					this.log.error(`Error gathering the Sample Create initial bundle: ${pError.message || pError}`, { stack: pError.stack });
					return fCallback();
				}
				return fCallback(pError);
			});
		}, pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-SampleCreate'].render();
		this.pict.views['PictSectionForm-SampleCreate'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * This method clears the current sample record.
	 * @param {boolean} pRender - If true, the view will be re-rendered after clearing the sample.
	 * @return {Promise<void>}
	 */
	async clearSample(pRender = true)
	{
		try
		{
			const newSample = { CreatingIDUser: 0 }; //FIXME: get from session (or hide that field on create maybe)
			this.AppData.SampleDetails = newSample;
			const session = await this.pict.providers.SessionProvider.getSession();
			if (session.LoggedIn)
			{
				newSample.CreatingIDUser = session.UserID;
			}
		}
		catch (error)
		{
			this.log.error(`Error getting session: ${error.message || error}`, { stack: error.stack });
		}
		finally
		{
			if (pRender)
			{
				await new Promise((resolve) => this.renderAsync(() =>
				{
					this.log.info('Sample Create view cleared');
					resolve();
				}));
			}
		}
	}

	async createNewSample(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new sample...');
		this.log.info(JSON.stringify(this.AppData.SampleDetails));

		const tmpSample = this.AppData.SampleDetails;
		// save the Sample
		try
		{
			delete tmpSample.CreatingIDUser;
			const tmpResult = await this.pict.providers.SampleProvider.createSample(tmpSample, null, true);
			this.AppData.SampleDetails = tmpResult;
			this.log.info('Sample created, going to the Details view...');
			this.goToReadView();
		}
		catch (error)
		{
			this.log.error('Error creating sample', error);
			this.pict.views.HeadlightPanels.toast({ message: `Error creating Sample: ${error.message || error}`, type: 'is-danger' });
		}
	}

	goToEditView()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to edit');
			return;
		}
		this.log.info('Going to Edit Sample view for Sample GUID:', this.AppData.SampleDetails.GUIDSample);
		this.pict.providers.LIMSRouter.router.navigate(`/Sample/${this.AppData.SampleDetails.GUIDSample}/Edit`);
	}

	goToReadView()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to view');
			return;
		}
		this.log.info('Going to Read Sample view for Sample GUID:', this.AppData.SampleDetails.GUIDSample);
		this.pict.providers.LIMSRouter.router.navigate(`/Sample/${this.AppData.SampleDetails.GUIDSample}`);
	}

	async saveSampleChanges()
	{
		this.log.info('Saving Sample changes');
		const tmpSample = this.AppData.SampleDetails;
		// save the Sample
		const tmpResult = await this.pict.providers.SampleProvider.updateSample(tmpSample);
		if (tmpResult)
		{
			this.log.info('Sample changes saved successfully');
			this.goToReadView();
			this.pict.views.HeadlightPanels.toast({ message: 'Sample changes saved successfully', type: 'is-success' });
		}
		else
		{
			this.log.error('Error saving Sample changes');
			this.pict.views.HeadlightPanels.toast({ message: 'Error saving Sample changes', type: 'is-danger' });
		}
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Sample form submitted');

		this.createNewSample(event);
	}
}

module.exports = LIMSSampleRecordCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSSampleRecordCreate',
	DefaultRenderable: 'LIMSSampleRecordCreate',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	Templates:
	[
		{
			Hash: 'LIMSSampleRecordCreate-Wrapper',
			Template: /*html*/`
			<form class="container form" data-sample-id="{~D:Record.IDSample~}" onsubmit="_Pict.views.LIMSSampleRecordCreate.handleFormSubmitAction(event);">
				{~T:LIMSSampleRecordCreate-NewSampleHeader:AppData.SampleDetails~}
				<!-- LIMSSampleRecordCreate Content -->
				<div id="LIMSSampleRecordPanel-Details-Content">
					<div id="LIMSSampleRecordCreate-Details-Container">{~T:LIMSSampleRecordCreate-Details:AppData.SampleDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSSampleRecordCreate-NewSampleHeader',
			Template: /*html*/`
				<header id="PRSP_Title_Container" class="p-5 pb-0 has-background-text-soft is-vcentered">
					<h2 class="title is-size-4" id="PRSP_Title">Create New Sample</h2>
				</header>`,
		},
		{
			Hash: 'LIMSSampleRecordCreate-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSSampleRecordCreate-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSSampleRecordCreate-Details-Buttons-Create:AppData.SampleDetails~}`,
		},
		{
			Hash: 'LIMSSampleRecordCreate-Details-Buttons-Create',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" class="button is-link is-soft" title="Clear sample" onclick="_Pict.views.LIMSSampleRecordCreate.clearSample()">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span class="icon-text">Clear</span>
					</button>
					<button type="submit" class="button is-link" title="Create new sample">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save New Sample</span>
					</button>
				</div>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSSampleRecordCreate',
			TemplateHash: 'LIMSSampleRecordCreate-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};
